// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__LBLq6","menu_closed":"Menu_menu_closed__Yo1gR","nav":"Menu_nav__CRF2e","navLink":"Menu_navLink__nYwjh","selected":"Menu_selected__EvFxw"};